module.exports = __webpack_public_path__ + "static/media/special-request-banner-mobile.83d7a9c8.png";